/* eslint-disable no-shadow */
import get from 'lodash.get';
import FilterClient from '../../api/FilterClient';

export const mutations = {
  setAutocompleteResults(state, response) {
    state.quickSearch.query = response.query;
    state.quickSearch.autocomplete = response.autocomplete;
    state.quickSearch.matches = response.matches;
  },
  setBuyingFilters(state, filters) {
    state.buyingFilters = filters;
  },
  setSearchHistory(state, response) {
    state.quickSearch.history = response.queries;
  },
  setSearchQuery(state, query) {
    state.quickSearch.query = query;
  },
  setSearchAutocomplete(state, autocomplete) {
    state.quickSearch.autocomplete = autocomplete;
  },
  setSearchMatches(state, matches) {
    state.quickSearch.matches = matches;
  },
  setSearchTags(state, tags) {
    state.quickSearch.tags = tags;
  },
};

export const actions = {
  getTagObject(match) {
    return {
      text: get(match, 'value', ''),
      type: get(match, 'type', ''),
      classes: get(match, 'type', '') === null ? 'invalid' : '',
    };
  },
  async getAutocomplete({ commit, state }, query) {
    state.loading = true;
    const filterClient = new FilterClient(this.state.authorization.user);
    const response = await filterClient.searchAutocomplete({ query });

    commit('setAutocompleteResults', response.data.data);
    state.loading = false;

    return response;
  },
  async getSearchHistory({ commit }) {
    const filterClient = new FilterClient(this.state.authorization.user);
    const response = await filterClient.searchHistory();

    commit('setSearchHistory', response.data.data);

    return response;
  },
  setAutocompleteResults({ commit }, autocompleteResults) {
    commit('setAutocompleteResults', autocompleteResults);
  },
  setSearchTags({ commit }, tags) {
    commit('setSearchTags', tags);
  },
  setSearchAutocomplete({ commit }, searchAutocomplete) {
    commit('setSearchAutocomplete', searchAutocomplete);
  },
  setSearchMatches({ commit }, matches) {
    commit('setSearchMatches', matches);
  },
  setSearchQuery({ commit }, query) {
    commit('setSearchQuery', query);
  },
};

export const getters = {
  quickSearchAutocomplete: (state) => state.quickSearch.autocomplete,
  quickSearchMatchedTypes: (state) => state.quickSearch.matches.map((match) => (match.type ? match.type.toLowerCase() : '')),
  quickSearchHistory: (state) => state.quickSearch.history,
  quickSearchIsActive: (state, getters) => getters.quickSearchMatchedTypes.length > 0,
  quickSearchQuery: (state) => state.quickSearch.query,
  quickSearchMatches: (state) => state.quickSearch.matches,
  quickSearchTags: (state) => state.quickSearch.tags,
  buyingFilters: (state) => state.buyingFilters || [],
  activeFilters: (state) => state.buyingFilters.filter((filter) => filter.is_filter_active),
  disabledFilters: (state, getters) => {
    const searchTypesToFilterTitleMap = {
      model: ['make', 'body type'],
      year: ['year'],
      make: ['make'],
    };

    return getters.quickSearchMatchedTypes.flatMap(
      (match) => searchTypesToFilterTitleMap[match],
    );
  },
  filterIsDisabled: (state, getters) => (filter) => getters.disabledFilters
    .includes(filter.title.toLowerCase()),
  loading: (state) => state.loading,
};

export const state = {
  buyingFilters: [],
  loading: false,
  quickSearch: {
    query: '',
    autocomplete: [],
    matches: [],
    history: [],
    tags: [],
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
